module.exports = __webpack_public_path__ + "img/0038.2eb19042.png";